import { parseCurrency } from "../../../../helpers/StringManipulation";
import { buildSelectedValues } from "../useCreateProduct";

const getEditedVariants = (rows, columns, variants, options) => {
  const variantColumns = columns.filter(
    (column) => !["price", "stock", "sku"].includes(column.stateKey)
  );

  const deletedOptionIds = getDeletedOptionIds(options, variantColumns);

  const editedVariants = rows
    .map(getEditedVariant(variants, deletedOptionIds, columns))
    .filter(getVariantHasChanges);

  return editedVariants;
};

const getDeletedOptionIds = (remoteOptions, localOptions) => {
  const remoteOptionsThatDontExistLocally = remoteOptions.filter(
    (remoteOption) => {
      const remoteOptionExistsLocally = localOptions.find(
        (localOption) => localOption.id === remoteOption.id
      );

      return !remoteOptionExistsLocally;
    }
  );

  return remoteOptionsThatDontExistLocally.map(({ id }) => id);
};

const getVariantHasChanges = (row) => row && Object.keys(row).length > 1;

const getEditedVariant = (variants, deletedOptionIds, columns) => (row) => {
  const matchingVariant = getMatchingVariant(row, variants, deletedOptionIds);
  if (!matchingVariant) return;

  const price = parseCurrency(matchingVariant.price) !==
    parseCurrency(row.price) && {
    price: parseCurrency(row.price)
  };

  const stock = parseInt(matchingVariant.stock) !== parseInt(row.stock) && {
    stock: parseInt(row.stock)
  };

  const sku = row.sku !== matchingVariant.sku.trim() && {
    sku: row.sku.trim()
  };

  // prettier-ignore
  return matchingVariant && {
      id: row.id,
      ...price,
      ...stock,
      ...sku,
      ...getSelectedValuesIfChanged(row, columns, matchingVariant)
    };
};
const getSelectedValuesIfChanged = (row, columns, matchingVariant) => {
  const variantValues = (({ id, price, sku, stock, ...variantOptions }) =>
    variantOptions)(row);

  const selectedValues = buildSelectedValues(variantValues, columns);

  const selectedValuesLengthsAreDifferent =
    matchingVariant.selectedValues.length !== selectedValues.length;

  const selectedValuesAreDifferent = getSelectedValuesAreDifferent(
    matchingVariant,
    selectedValues
  );

  // prettier-ignore
  return (selectedValuesLengthsAreDifferent || selectedValuesAreDifferent)
    && {
      selectedValues: selectedValues.map(({ optionName, valueName }) => ({
        optionName,
        valueName
      }))
    };
};

const getSelectedValuesAreDifferent = (matchingVariant, selectedValues) => {
  const getSelectedValueIsDifferent = (matchingSelectedValue) =>
    !selectedValues.find(
      (selectedValue) =>
        selectedValue.valueName === matchingSelectedValue.name &&
        selectedValue.optionName === matchingSelectedValue.option.name
    );

  const differentSelectedValues = matchingVariant.selectedValues.filter(
    getSelectedValueIsDifferent
  );

  return !!differentSelectedValues.length;
};

const getMatchingVariant = (row, variants, deletedOptionIds) => {
  const matchingVariant = variants.find((variant) => row.id === variant.id);
  if (!matchingVariant) return;

  return {
    ...matchingVariant,
    selectedValues: getNotDeletedSelectedValues(
      matchingVariant,
      deletedOptionIds
    )
  };
};

const getNotDeletedSelectedValues = (matchingVariant, deletedOptionIds) =>
  matchingVariant.selectedValues.filter(
    (matchingSelectedValue) =>
      !deletedOptionIds.includes(matchingSelectedValue.option.id)
  );

export default getEditedVariants;
